module.exports = __webpack_public_path__ + "static/media/icon-remove.803a2bc6.svg";